<template>
  <div class="scoll-container">
    <slot />
  </div>
</template>

<script>
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.yearTl.kill();
  },
  methods: {
    init() {
      // year animation
      this.yearTl = gsap.timeline({
        ease: "power1.in",
      });
      const present = document.querySelector(".year-2024");
      const container = document.querySelector(".years");
      const c = container.getBoundingClientRect();
      const p = present.getBoundingClientRect();
      this.yearTl.from(
        ".year-2024",
        {
          y: -(c.height - p.height),
          textContent: "1974",
          snap: { textContent: 1 },
          opacity: 0,
          delay: 0.35,
          duration: 1.5,
          color: "#e3e3e3",
        },
        0
      );
      this.yearTl.from(
        ".line",
        {
          height: "0%",
          delay: 0.5,
          duration: 1.5,
        },
        0
      );

      const textBlocks = gsap.utils.toArray(".text-block--text");
      // Intro text
      textBlocks.forEach((textblock) => {
        gsap.to(textblock, {
          opacity: 1,
          yPercent: -20,
          duration: 0.39,
          scrollTrigger: {
            trigger: textblock,
            start: "top 85%",
            end: "top 85%",
            toggleActions: "play none none reverse",
          },
        });
      });

      // show timeline section
      gsap.to(".timeline-section-inner", {
        scrollTrigger: {
          trigger: ".timeline-section-inner",
          start: "top 85%",
          end: "bottom 15%",
          toggleClass: "lift",
        },
      });
    },
  },
};
</script>

<style>
.scoll-container {
  display: flex;
  flex-flow: column;
}
</style>
